import { StoreSetupDraft } from '../../types/storeSetup.types';
import { SetupBeat } from './setupDraft';

export type SetupTab = 'board' | 'orders' | 'flow';

export function setupTabFor(setup: StoreSetupDraft, id: string | null): SetupTab | null {
  if (!id) return null;
  if (setup.automations.some((item) => item.id === id)) return 'flow';
  if (setup.charts.some((item) => item.id === id)) return 'board';
  const search = setup.searches.find((item) => item.id === id);
  if (search) return search.dashboard ? 'board' : 'orders';
  if (setup.statuses.some((item) => item.id === id)) return 'orders';
  if (setup.fields.some((item) => item.id === id)) return 'orders';
  return null;
}

export function setupOn(id: string, beat: SetupBeat | null): string {
  return beat?.itemId === id ? ' is-on' : '';
}

export function setupCount(name: string): number {
  const total = name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return (total % 36) + 4;
}
